
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pos",
      function () {
        return require("private-next-pages/pos.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pos"])
      });
    }
  